import React from 'react';
import './FreightMasters.css';
import { FaTrophy, FaBolt } from 'react-icons/fa';

const FreightMasters = () => {
  const [activeTab, setActiveTab] = React.useState('global');

  const globalPlayers = [
    { rank: 1, name: 'Emma Garcia', company: 'RoadRunner Logistics', freightBooked: 8920, points: 2250, reward: 15000, avatar: 'EG' },
    { rank: 2, name: 'David Park', company: 'FastTrack Brokers', freightBooked: 7650, points: 1920, reward: 10000, avatar: 'DP' },
    { rank: 3, name: 'Sarah Chen', company: 'Your Company', freightBooked: 4850, points: 1250, reward: 8000, avatar: 'SC', globalRank: 3 },
    { rank: 4, name: 'Jessica Martinez', company: 'Prime Freight Co', freightBooked: 4320, revenue: 108000, points: 1080, reward: 5000, avatar: 'JM' },
    { rank: 5, name: 'Marcus Johnson', company: 'Your Company', freightBooked: 3920, revenue: 98000, points: 980, reward: 2000, avatar: 'MJ', globalRank: 5 },
  ];

  const companyPlayers = [
    { rank: 1, name: 'Sarah Chen', company: 'Your Company', freightBooked: 4850, points: 1250, reward: 8000, avatar: 'SC', globalRank: 3 },
    { rank: 2, name: 'Marcus Johnson', company: 'Your Company', freightBooked: 3920, points: 980, reward: 2000, avatar: 'MJ', globalRank: 5 },
    { rank: 3, name: 'Alex Rodriguez', company: 'Your Company', freightBooked: 3450, points: 850, reward: 0, avatar: 'AR', globalRank: 12 },
    { rank: 4, name: 'Jamie Williams', company: 'Your Company', freightBooked: 2890, revenue: 72000, points: 650, reward: 0, avatar: 'JW', globalRank: 28 },
    { rank: 5, name: 'Taylor Kim', company: 'Your Company', freightBooked: 2450, revenue: 61000, points: 520, reward: 0, avatar: 'TK', globalRank: 35 },
  ];

  const players = activeTab === 'global' ? globalPlayers : companyPlayers;
  const topPlayers = players.slice(0, 3);
  const otherPlayers = players.slice(3);

  return (
    <div className="freight-masters-page">
      <header className="fm-header">
        <h1><FaTrophy /> Freight Masters <FaBolt /></h1>
        <p>Book smarter, earn more. Track your performance and climb to the top.</p>
        <div className="fm-info-boxes">
          <div className="info-box">Monthly Refresh: <strong>7 days remaining</strong></div>
          <div className="info-box">Prize Pool: <strong>$50,000 this month</strong></div>
        </div>
      </header>

      <div className="fm-rankings">
        <div className="fm-tabs">
          <button className={`tab-btn ${activeTab === 'company' ? 'active-company' : ''}`} onClick={() => setActiveTab('company')}>Company Rankings</button>
          <button className={`tab-btn ${activeTab === 'global' ? 'active-global' : ''}`} onClick={() => setActiveTab('global')}>Global Rankings</button>
        </div>

        {activeTab === 'global' && (
          <div className="fm-prize-pool">
            <h2>Global Prize Pool</h2>
            <p>All brokers compete for the same reward pool across your entire network. Rank higher globally to earn bigger rewards.</p>
            <div className="total-prize">
              <span>Total Prize Pool:</span>
              <strong>$100,000</strong>
            </div>
            <div className="prize-tiers">
              <div className="prize-tier tier-1"><strong>1st</strong> $15,000</div>
              <div className="prize-tier tier-2"><strong>2nd</strong> $10,000</div>
              <div className="prize-tier tier-3"><strong>3rd</strong> $8,000</div>
              <div className="prize-tier tier-4-5"><strong>4-5th</strong> $5,000</div>
              <div className="prize-tier tier-6-10"><strong>6-10th</strong> $2,000</div>
            </div>
          </div>
        )}

        <div className="fm-top-players">
          {topPlayers.map(player => (
            <div key={player.rank} className={`player-card rank-${player.rank}`}>
              <div className="player-rank-badge">{player.rank}</div>
              <div className="player-avatar">{player.avatar}</div>
              <h3>{player.name}</h3>
              <p>{player.company}</p>
              {player.globalRank && <div className="global-rank">Global Rank: #{player.globalRank}</div>}
              <div className="player-stats">
                <div><span>Freight Booked</span><strong>{player.freightBooked.toLocaleString()}</strong></div>
                <div><span>Points</span><strong>{player.points.toLocaleString()}</strong></div>
              </div>
              {player.reward > 0 && <div className="player-reward">${player.reward.toLocaleString()} reward</div>}
            </div>
          ))}
        </div>

        <div className="fm-player-list">
          {otherPlayers.map(player => (
            <div key={player.rank} className="player-row">
              <div className="player-rank">{player.rank}</div>
              <div className="player-info">
                <div className="player-avatar-small">{player.avatar}</div>
                <div>
                  <strong>{player.name}</strong>
                  <p>{player.company} {player.globalRank && <span>&bull; Global Rank: #{player.globalRank}</span>}</p>
                </div>
              </div>
              <div className="player-list-stats">
                <div><span>Freight Booked</span><strong>{player.freightBooked.toLocaleString()}</strong></div>
                {player.revenue && <div><span>Revenue</span><strong>${player.revenue.toLocaleString()}</strong></div>}
                <div><span>Points</span><strong>{player.points.toLocaleString()}</strong></div>
              </div>
              {player.reward > 0 && <div className="player-list-reward">${player.reward.toLocaleString()}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FreightMasters;